"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBERVALUE = void 0;
exports.NUMBERVALUE = {
    alias: 'VALORNUMERICO',
    description: 'Converte texto em um número, de maneira independente de localidade',
    arg_names: ['texto', 'separador_decimal'],
    args_description: [
        'O texto a ser convertido em um número',
        'O caractere usado para separar o inteiro e a parte fracional do resultado',
    ],
};
